<template>
  <div class="d-flex justify-content-between align-items-center">
    <div class="ml-3">
      <strong>Versão:</strong>
      {{version}}
      <br />
      <strong>Build Date:</strong>
      {{buildDate}}
    </div>
    <div class="mt-2 text-right">
      <router-link to="/marshall" class="btn btn-secondary text-right mr-3">Geral</router-link>
      <router-link to="/marshall/rede" class="btn btn-secondary text-right mr-3">Rede</router-link>
      <button style class="btn btn-danger text-right mr-3" @click="logout()">Logout</button>
    </div>
  </div>
</template>

<script>
import API from "../../utils/api";
let $api;
export default {
  data() {
    return { version: "", buildDate: "" };
  },
  created() {
    $api = new API();
    $api.getVersion().then(v => {
      this.version = v.data.versao;
      this.buildDate = v.data.buildDate;
    });
  },
  methods: {
    logout() {
      $api.doLogout();
      this.$router.push("/");
    }
  }
};
</script>

<style>
</style>